/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "25c8d70503a017c8d2b0adeec4ae9676719376b1";
